import {
  HttpErrorResponse,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { logHttpContext } from '@core/constants/log-http-context';
import { Memory } from 'src/app/core/interfaces/memory';
import { MonitoringService } from 'src/app/core/services/monitoring.service';
import { FeatureMap } from 'src/app/shared/types/feature-map.type';

interface Adaptation {
  feature: string;
  requestTimeSec: number;
  requestTimeSecBackend?: number | false;
  requestTimeSecTraffic?: number | false
  url: string;
  method: string;
  status: number;
  success: boolean;
  memory?: Memory;
  requestBody?: any;
  requestResponse?: any;
  requestParams?: any;
  controlTouch?: boolean;
  customParameters?: any
  appName: string;
  requestId?: string;
  exceptionCode?: string;
  channel?: string | null;
}

function isSuccessfulResponse(
  response: HttpErrorResponse | HttpResponse<any> | undefined
): boolean {
  return (
    Boolean(response?.ok) || response?.status === HttpStatusCode.NotModified
  );
}

export function livechatPerformanceLogAdapter(
  request: HttpRequest<any>,
  response: HttpErrorResponse | HttpResponse<any> | undefined,
  startTime: number,
  feature: FeatureMap,
  monitoring: MonitoringService,
  appName: string,
  channel: string | null
): Adaptation {
  const requestTimeSec = (Date.now() - startTime) / 1000;
  const requestTimeSecBackend = Number(response?.headers?.get('execution-time')) || false;
  const requestTimeSecTraffic = requestTimeSecBackend ? Number(Number(requestTimeSec - requestTimeSecBackend).toFixed(3)) : false;
  const controlTouch = Boolean(response?.headers?.get('control-touch')) || false;
  const requestId = request.headers?.get('asksuite-request-id') || "";
  const exceptionCode = response?.headers?.get('exception-code') || "";
  return {
    appName,
    customParameters: request.context.get(logHttpContext),
    feature: feature,
    channel,
    exceptionCode,
    requestId,
    requestTimeSec,
    requestTimeSecBackend,
    requestTimeSecTraffic,
    url: request.urlWithParams,
    method: request.method,
    status: response?.status ?? 0,
    success: isSuccessfulResponse(response),
    requestBody: request?.body,
    requestResponse: (response as any)?.error,
    controlTouch,
  };
}

